export default [
    'userid',
    'facebookId',
    'accessToken',
    'password',
    'emailAddress',
    'gender',
    'birthday',
    'timezone',
    'deactivated',
    'deactivatedDate',
    'displayName',
    'slug',
    'dateCreated',
    'lastActive',
    'usertype',
    'verified',
    'avatar',
    'location',
    'website',
    'description',
    'bannerImage',
    'facebook',
    'twitter',
    'instagram',
    'intro_video',
    'curatorPending',
    'curatorRejected',
    'tutorialComplete',
    'amazonsubaffiliateid',
    'blog',
    'tumblr',
    'digitalmagazine',
    'youtube',
    'pinterest',
    'other',
    'medium',
    'why',
    'interests',
    'featured',
    'profession_fk',
    'categories',
    'pro_published',
];
